export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12086.2f125f57.jpg";